import React, { Component, Suspense } from 'react';
import { Route, Switch } from "react-router-dom";
import Home from "./home/home";
import About from "./about/about";
// import Services from "./services/services";
import Projects from "./projetcs/projects";
import Contact from "./contact/contact";
import Imprint from "./imprint";
import Privacy from "./privacy";
import Content from "./content";
import Navigation from "./topbar/navigation";
import ScrollNavigation from "react-single-page-navigation";
import { PuffLoader } from "react-spinners";
import Stamps from './stamps/stamps';

// export default class Routing extends Component {
//     render() {
//         return (
//             <div id="routing">
//                 <Switch>
//                     <Route exact path="#home" component={Home}/>
//                     <Route exact path="#about" component={About}/>
//                     {/*<Route exact path="#services" component={Services}/>*/}
//                     <Route exact path="#projects" component={Projects}/>
//                     <Route exact path="#contact" component={Contact}/>
//                     <Route exact path={'/imprint'} render={() => (<Imprint/>)}/>
//                     <Route exact path={'/privacy'} render={() => (<Privacy/>)}/>
//                     default route is always the app itself
//                     <Route render={() => (
//                         <ScrollNavigation elements={{Home: {}, About: {}, Projects: {}, Contact: {}}}
//                                           offset={-50}>
//                             {({refs, activeElement, goTo}) => (
//                                 <Suspense fallback=
//                                               {
//                                                   <div className={'center'}>
//                                                       <PuffLoader color={'#5c7ad6'} loading={true}/>
//                                                   </div>
//                                               }>
//                                     <div>
//                                         <Navigation useSuspense={true}
//                                                     refs={refs}
//                                                     activeElement={activeElement}
//                                                     goTo={goTo}
//                                                     isSticky={this.props.isSticky}/>
//                                         <Content useSuspense={true}
//                                                  element={this.props.element}
//                                                  refs={refs}/>
//                                     </div>
//                                 </Suspense>
//                             )}
//                         </ScrollNavigation>
//                     )}/>
//                 </Switch>
//             </div>
//         );
//     }
// }

export default class Routing extends Component {
    componentDidMount() {
      window.addEventListener("scroll", this.checkIfBottom);
    }
  
    componentWillUnmount() {
      window.removeEventListener("scroll", this.checkIfBottom);
    }
  
    checkIfBottom = () => {
      const scrollTop = window.scrollY;
      const clientHeight = window.innerHeight;
      const scrollHeight = document.documentElement.scrollHeight;
  
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        this.setState({ atBottom: true });
      } else {
        this.setState({ atBottom: false });
      }
    };
  
    state = { atBottom: false };
  
    render() {
      return (
        <div id="routing">
          <Switch>
            <Route exact path="#home" component={Home} />
            <Route exact path="#about" component={About} />
            <Route exact path="#projects" component={Projects} />
            <Route exact path="#stamps" component={Stamps} />
            <Route exact path="#contact" component={Contact} />
            <Route exact path={"/imprint"} render={() => <Imprint />} />
            <Route exact path={"/privacy"} render={() => <Privacy />} />
            <Route
              render={() => (
                <ScrollNavigation
                  elements={{ Home: {}, About: {}, Projects: {}, Stamps: {}, Contact: {} }}
                  offset={-70}
                >
                  {({ refs, activeElement, goTo }) => {
                    // if user is at bottom and not on "Contact"
                    if (this.state.atBottom && activeElement !== "Contact") {
                      activeElement = "Contact";
                    }
  
                    return (
                      <Suspense
                        fallback={
                          <div className={"center"}>
                            <PuffLoader color={"#5c7ad6"} loading={true} />
                          </div>
                        }
                      >
                        <div>
                          <Navigation
                            useSuspense={true}
                            refs={refs}
                            activeElement={activeElement}
                            goTo={goTo}
                            isSticky={this.props.isSticky}
                          />
                          <Content
                            useSuspense={true}
                            element={this.props.element}
                            refs={refs}
                          />
                        </div>
                      </Suspense>
                    );
                  }}
                </ScrollNavigation>
              )}
            />
          </Switch>
        </div>
      );
    }
  }